import SummaryPreviewTable from './SummaryPreviewTable';

export {
  SummaryPreviewTable,
};



// WEBPACK FOOTER //
// ./src/views/ReportPreview/components/index.js